import { Alert, cn } from "@au-schein-de/au-ui-library";

type ProductSoldOutProps = {
	text: string;
	className?: string;
	withIcon?: boolean;
	color?: "gray" | "warning" | "info" | "error" | "success";
	variant?:
		| "warning"
		| "info"
		| "success"
		| "default"
		| "destructive"
		| null
		| undefined;
};

export const ProductSoldOut = ({
	text,
	className,
	withIcon,
	color = "gray",
	variant = "default",
}: ProductSoldOutProps) => {
	return (
		<Alert
			color={color}
			className={cn("bg-white p-2 w-fit", className)}
			translate="yes"
			withIcon={withIcon}
			variant={variant}
			data-testid="product-sold-out"
		>
			<Alert.Description>{text}</Alert.Description>
		</Alert>
	);
};
